module.exports = __webpack_public_path__ + "img/stock2.bbcc3834.png";